import { Card, Checkbox, Col, Form, Input, Row, Typography } from "antd";
import React, { useState, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
const { Title } = Typography;

const Authorization = ({ getChildData, patientDetailsData }) => {
  const { t, i18n } = useTranslation();
  const [signatureActive, setSignatureActive] = useState(false);

  const callparent = (e, name) => {
    getChildData(e, name);
  };

  const validateAuthorization = useCallback((_, value) => {
    if (value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("patientDetails:please_accept_the_authorization")));
  }, [t]);

  const validateTermsAndConditions = useCallback((_, value) => {
    if (value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("patientDetails:please_accept_the_term_and_condition")));
  }, [t]);

  const validationRules = useMemo(() => ({
    authorization: [
      { validator: validateAuthorization }
    ],
    signature: [
      { required: true, message: t("patientDetails:please_enter_signature") }
    ],
    termsAndConditions: [
      { validator: validateTermsAndConditions }
    ]
  }), [t, validateAuthorization, validateTermsAndConditions]);
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("patientDetails:authorization")}
        </Title>
      }
    >
      <Row gutter={[0, 10]} className="px-6">
        <Col span={24}>
          <Form.Item
            name="Authorization_Auth1"
            valuePropName="checked"
            onChange={(e) =>
              callparent(e.target.checked, "Authorization_Auth1")
            }
            checked={patientDetailsData.Authorization_Auth1}
            className="checkbox-align-top"
            rules={validationRules.authorization}
          >
            <Checkbox className="font-medium">
              {t("patientDetails:auth_desc_1")}
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="Authorization_Auth2"
            valuePropName="checked"
            checked={patientDetailsData.Authorization_Auth2}
            onChange={(e) =>
              callparent(e.target.checked, "Authorization_Auth2")
            }
            className="checkbox-align-top"
            rules={validationRules.authorization}
          >
            <Checkbox className="font-medium">
              {t("patientDetails:auth_desc_2")}
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="Authorization_Auth3"
            valuePropName="checked"
            checked={patientDetailsData.Authorization_Auth3}
            onChange={(e) =>
              callparent(e.target.checked, "Authorization_Auth3")
            }
            className="checkbox-align-top"
            rules={validationRules.authorization}
          >
            <Checkbox className="font-medium">
              {t("patientDetails:auth_desc_3")}
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            wrapperCol={{ lg: 12 }}
            onChange={(e) =>
              callparent(e.target.value, "Authorization_Signature")
            }
            name="Authorization_Signature"
            label={t("patientDetails:auth_desc_4")}
            className={`signature ${
              patientDetailsData.Authorization_Signature != "" ||
              signatureActive
                ? ""
                : "auth-watermark"
            }`}
            rules={validationRules.signature}
          >
            <Input
              maxLength={100}
              onBlur={() => {
                setSignatureActive(false);
              }}
              onFocus={() => {
                setSignatureActive(true);
              }}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="Authorization_Auth4"
            checked={patientDetailsData.Authorization_Auth4}
            valuePropName="checked"
            onChange={(e) =>
              callparent(e.target.checked, "Authorization_Auth4")
            }
            className="checkbox-align-top"
            rules={validationRules.termsAndConditions}
          >
            <Checkbox className="font-medium">
              {t("patientDetails:auth_desc_5")}{" "}
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};
export default Authorization;
